import { Component, EventEmitter, Inject, OnInit, Output } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms'; // Import FormBuilder and Validators
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { NoResponseService } from './no-response.service';
import { ToastrService } from 'ngx-toastr';
import { BehaviorSubject, Subject } from 'rxjs';

@Component({
  selector: 'app-no-response',
  templateUrl: './no-response.component.html',
  styleUrls: ['./no-response.component.css']
})
export class NoResponseComponent implements OnInit {
  @Output() successfulSubmission: EventEmitter<any> = new EventEmitter<any>();
  noresponseForm!: FormGroup;
  submitted = false;
  formData: any;
  masters: any = [];
  noResponseReason: any = [];
  isLoading: Subject<boolean> = new Subject<boolean>();
  leadId: string | undefined; 

  constructor(public dialogRef: MatDialogRef<NoResponseComponent>, private formBuilder: FormBuilder, private noResponseService:NoResponseService,
    private toastr: ToastrService, @Inject(MAT_DIALOG_DATA) public data: any,
   ) {}

  ngOnInit() {
    this.leadId = this.data.leadId;
    const masters = JSON.parse(sessionStorage.getItem('masters') || '{}');

    if (masters) {
      this.masters = masters;
      this.noResponseReason = this.masters.noResponseReason || [];
  }
    
    this.noresponseForm = this.formBuilder.group({
      no_response_reason: ['',Validators.required],
      remarks: [''],
      id: [this.leadId],
      stage_id:"4:No Response",
    });
  }

  get f() {
    return  this.noresponseForm.controls
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  onSubmit(): void {
    this.submitted = true;
    if (!this.noresponseForm.valid) {
      return
    }else{
      const formData: any = this.noresponseForm.value;
      this.isLoading = new BehaviorSubject<boolean>(true);

      this.noResponseService.noresponse(formData).subscribe((response: any) => {
        let responseData = response.body;
        if (responseData.responseCode == 200) {
          this.successfulSubmission.emit();
          this.dialogRef.close(this.formData);
          this.isLoading = new BehaviorSubject<boolean>(false);
          this.toastr.success("Lead Moved to No Response successfully!");
      
        } else {
          this.isLoading = new BehaviorSubject<boolean>(false);
          this.toastr.error("Please try again later!");
        }
      }, (err: any) => {
        this.isLoading = new BehaviorSubject<boolean>(false);
      });
    }
  }
}